// Add Items modal: the item cards board for an existing inquiry. Existing
// items render as cards (edit/delete in place), the placeholder card adds new
// ones — each persists individually, so there is no batch save and no footer
// button: the wizard's "Save item" is the only action, the X closes. This is
// the same board the New Inquiry modal shows as its second stage.

import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from 'design-system';
import { ItemCardsBoard } from 'pages/inquiry-processor/components/item-board';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  inquiryId: string;
}

export const AddItemsModal = ({ isOpen, onClose, inquiryId }: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={{ base: 'full', md: '6xl' }} scrollBehavior='inside'>
      <ModalOverlay />
      <ModalContent maxW={{ base: '100vw', md: 'min(1880px, 98vw)' }}>
        <ModalHeader>Inquiry Items</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb='6'>
          <ItemCardsBoard inquiryId={inquiryId} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
